/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-21 13:36:43
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-07-06 14:59:37
 * @FilePath: \xm-runing-main\src\components\xm-tenant-and-industry-toggle\stores\xm-tenant-and-industry-dropdown.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  ref,
  computed
} from 'vue'

import {
  MenuProps,
  DropdownProps
} from 'ant-design-vue'

import {
  useXmAgentAndIndustryToggleStore
} from '.'
import { useXmTenantAndIndustryModalStore } from './xm-tenant-and-industry-modal'
import { useXmTenantAndIndustryFormStore } from './xm-tenant-and-industry-form'

import {dbUtils} from 'xmgoing-utils'

export const useXmTenantAndIndustryDropdownStore = defineStore('xm-tenant-and-industry-dropdown', () => {
  const XmAgentAndIndustryToggleStore = useXmAgentAndIndustryToggleStore()
  const XmAgentAndIndustryModalStore = useXmTenantAndIndustryModalStore()
  const XmAgentAndIndustryFormStore = useXmTenantAndIndustryFormStore()

  const {
    tenantList,
    isMultiple
  } = storeToRefs(XmAgentAndIndustryToggleStore)

  const {
    visible
  } = storeToRefs(XmAgentAndIndustryModalStore)

  const {
    model
  } = storeToRefs(XmAgentAndIndustryFormStore)

  const dropdownProps = computed<DropdownProps>(() => {
    return {
      placement: 'bottomRight'
    }
  })

  const selectedKeys = ref<MenuProps['selectedKeys']>([])

  const menuProps = computed<MenuProps>(() => {
    return {
      selectable: true,
      selectedKeys: selectedKeys.value,
    }
  })

  const currentTitle = computed(() => {
    const userInfo = dbUtils.getCachUser();
    const id = userInfo?.id

    let title = ''

    tenantList.value.findIndex(tenant => {
      if (tenant.value === id) {
        title = tenant.title
        selectedKeys.value = [tenant.value]
        return true
      }

      return tenant.children!.findIndex(industry => {
        if (industry.value === id) {
          title = industry.title
          selectedKeys.value = [tenant.value, industry.value]
          return true
        }
        return false
      }) > -1
    })

    return title
  })

  const onSelect: MenuProps['onSelect'] = ({selectedKeys: keys, keyPath}) => {
    selectedKeys.value = keys
    model.value.tenantCode = keyPath as string[]
    visible.value = true
  }

  function reset () {
    selectedKeys.value = []
  }

  watch(visible, () => {
    if (!visible.value) {
      reset()
    }
  })

  return {
    currentTitle,
    dropdownProps,
    menuProps,
    tenantList,
    onSelect,
    isMultiple
  }
})
